/* eslint-disable camelcase */
import { t } from 'i18next';

import { eventAction, eventCategory, EVENT, sendGTMEvent } from '~utils/analytics';
import { formatDate, dateToTime } from '~utils/time';
import { capitalizeFirstLetter } from '~utils/string';
import { hyphensToCamelCase } from '~utils/functions';

const getVariantError = variantError => {
  const splitMessage = variantError.split('-');
  return {
    pizza: splitMessage?.[0] && splitMessage[0],
    crust: splitMessage?.[1] && t(`Home:${splitMessage[1]}`).toLowerCase(),
    size: splitMessage?.[2] && t(`Home:${splitMessage[2]}`).toLowerCase()
  };
};

export const sendCouponEvent = (isValid, code) => {
  sendGTMEvent(EVENT.eventPJ, {
    eventActionCategory: eventCategory.interaction,
    action: isValid ? eventAction.validCoupon : eventAction.invalidCoupon,
    label: code
  });
};

export const getInitialState = redeemedCode => ({
  activeInput: true,
  error: false,
  code: redeemedCode,
  activeCode: false
});

export const formatExtraMetadata = (extraMetadata, sizesAndCrusts) => {
  const data = {
    ...extraMetadata,
    invalid_offer: extraMetadata?.invalid_offer?.name,
    coupon_payment_method: capitalizeFirstLetter(extraMetadata.coupon_payment_method),
    expiry_date: formatDate(extraMetadata.expiry_date),
    expiry_time: dateToTime(extraMetadata.expiry_time),
    start_date: formatDate(extraMetadata.start_date),
    start_time: dateToTime(extraMetadata.start_time),
    availability_days: extraMetadata?.availability_days
      ?.reduce((days, day) => [...days, t(`StoreLanding:${day}`)], [])
      .join(', '),
    variant_error: extraMetadata?.error && getVariantError(extraMetadata.error),
    variant: extraMetadata?.variant && sizesAndCrusts.sizes?.[hyphensToCamelCase(extraMetadata.variant)],
    category:
      extraMetadata?.category &&
      t('ReedeemCode:toCategory', { category: t(`Menu:${extraMetadata.category}`) })
  };
  return data;
};
